import React, { Component } from 'react';
import ReactModal from 'react-modal';
import Linkify from 'react-linkify';
import classnames from 'classnames';
import './style.sass';

export default class Image extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  constructor () {
    super();
    this.state = {
      showModal: false
    };
    
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  
  handleOpenModal () {
    this.setState({ showModal: true });
  }
  
  handleCloseModal () {
    this.setState({ showModal: false });
  }

  render() {
    const { className, slug, id, title, content } = this.props;
    const imgSrc = "/portfolio/" + slug + "/" + id + ".png";

    return (
      <div className={classnames('Image', className)}>
        <img onClick={this.handleOpenModal} src={imgSrc} className="Image-preview" />
        <ReactModal 
           isOpen={this.state.showModal}
           contentLabel="Minimal Modal Example"
           onRequestClose={this.handleCloseModal}
           shouldCloseOnOverlayClick={true}
           className="Modal"
        >
          <img src={imgSrc} className="Modal-image" />
          <div className="Modal-body">
            <div className="Modal-title">
              {title}
            </div>
            <div className="Modal-content">
              <Linkify>{content}</Linkify>
            </div>
          </div>
        </ReactModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Image/index.js